import React from 'react';

import { UseFormReturn } from 'react-hook-form';

import { Company } from '_lib/api/apiTypes.shim';
import { WarningAlert } from '_lib/components/Alert/Alert';
import { Typography } from '_lib/components/Typography/Typography';
import { AuthUser } from '_lib/featureComponents/auth/auth.types';

import {
  CompanyConfigNotesForm,
  CompanyConfigNotesFormValues,
  companyConfigNotesFormValues
} from '../../CompanyFormItems/CompanyConfigNotesForm/CompanyConfigNotesForm';
import { FormWrapper } from '../../CompanyFormItems/FormWrapper/FormWrapper';

import { TabChangeObj } from '../CompanyUpdate';

import { useCompanyUpdateForm } from './hooks/useCompanyUpdateForm';

export type CompanyConfigNotesProps = {
  company: Company;
  authUser: AuthUser;
  tabChangeObj: TabChangeObj;
};

export const CompanyConfigNotes = (props: CompanyConfigNotesProps) => {
  const { company, authUser, tabChangeObj } = props;

  const { companyUpdateFormContext, validationErrors, allErrors, handleSave, isPending } = useCompanyUpdateForm({
    company,
    authUser,
    formValuePaths: companyConfigNotesFormValues,
    tabChangeObj,
    snackMessage: 'Company notes saved'
  });

  return (
    <FormWrapper
      isFetchingOrPending={isPending}
      formValues={companyUpdateFormContext.getValues()}
      onSave={handleSave}
      validationErrors={validationErrors}
      allErrors={allErrors}
      disabled={!company?.isActive}>
      {company?.isZoned && (
        <WarningAlert>
          <Typography text='Notes, Dispatch Rules, Big Ticket Items, Big Ticket Item Rules, and Warranty Handling fields can be overwritten by individual zones.' />
        </WarningAlert>
      )}
      <CompanyConfigNotesForm
        // TODO: bug where TS gets confused about having only nested fields in the DTO
        companyConfigNotesFormContext={
          companyUpdateFormContext as unknown as UseFormReturn<CompanyConfigNotesFormValues>
        }
        disabled={!company?.isActive}
      />
    </FormWrapper>
  );
};
